<template>
    <div v-if="source.content" class="flex h-12 w-full justify-center overflow-hidden bg-[#F8F8F8]">
        <div class="flex h-full w-full items-center justify-between px-8 max-lg:hidden lg:max-w-[1024px] xl:max-w-[1280px]">
            <div v-for="item in source.content" :key="item.text" class="flex justify-between space-x-2">
                <img :src="ossPath + item.img" :alt="item.text" class="h-4 w-4" />
                <span class="text-sm">{{ item.text }}</span>
            </div>
        </div>

        <div ref="tipsSplide" class="splide flex h-full items-center lg:hidden">
            <div class="splide__track">
                <ul class="splide__list">
                    <li v-for="item in source.content" :key="item.text" class="splide__slide flex justify-center space-x-2">
                        <img :src="ossPath + item.img" :alt="item.text" class="h-4 w-4" />
                        <span class="text-sm">{{ item.text }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import Splide from "@splidejs/splide";
const tipsSplide = ref();
const props = defineProps<{
    source: any;
}>();

function initSwiper() {
    new Splide(tipsSplide.value, {
        type: "loop",
        pagination: false,
        focus: "center",
        perMove: 1,
        perPage: 1,
        speed: 400,
        autoplay: true,
        arrows: false,
    }).mount();
}

onMounted(async () => {
    await nextTick();
    initSwiper();
});
</script>
<style lang="scss" scoped></style>
